import DataTable from "../../../components/Table";
import type { ColumnsType } from "antd/es/table";
import { Row, Col, Button, Space, Popconfirm, message } from "antd";
import { DeleteOutlined, SendOutlined } from "@ant-design/icons";
import PostSearch from "./EmailFollowSearch";
import { useEffect, useState } from "react";
import AddPost from "./AddEmailFollow";
import {
  callDeleteEmailFollow,
  callFetchEmailFollow,
  callFetchSendEmail,
} from "../../../config/api";
import ModalPost from "./ModalEmailFollow";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE_DISPLAY } from "../../../utils/constants/timeFormat";

interface DataType {
  key: React.Key;
  idTopic: string;
  idCategory: string;
  description: string;
  image: string;
}

function EmailFollow() {
  const [open, setOpen] = useState(false);

  const [searchData, setSearchData] = useState("");
  const [searchPagination, setSearchPagination] = useState(
    "current=1&pageSize=10&sort=-createdAt"
  );
  const [emailFollow, setEmailFollow] = useState<any>();
  const columns: ColumnsType<DataType> = [
    {
      title: "Email",
      dataIndex: "email",
    },

    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "UpdatedAt",
      dataIndex: "updatedAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record: any) => (
        <Space size="middle">
          <ModalPost
            id={record._id}
            handleFetchEmailFollow={fetchEmailFollow}
          />
          <Popconfirm
            placement="leftTop"
            title={"Xác nhận xóa user"}
            description={"Bạn có chắc chắn muốn xóa user này ?"}
            onConfirm={() => handleDeleteEmailFollow(record._id)}
            okText="Xác nhận"
            cancelText="Hủy">
            <Button type="primary" danger ghost>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  let query = `${searchPagination}${searchData}`;
  const fetchEmailFollow = async (param: any) => {
    const res = await callFetchEmailFollow(param);
    setEmailFollow(res.data);
  };

  const handleDeleteEmailFollow = async (id: string) => {
    const result = await callDeleteEmailFollow(id);
    if (result.statusCode === 200) {
      fetchEmailFollow(query);
      message.success("delete success!");
    } else {
      message.error("delete failed!");
    }
  };
  const handleSearch = (paramSearch: any) => {
    setSearchData(paramSearch);
  };

  query += searchData;
  useEffect(() => {
    fetchEmailFollow(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, open]);
  const handleSendEmail = async () => {
    const res = await callFetchSendEmail();
    if (res.message) {
      message.success(res.message);
    }
  };

  const handleModalCreate = (): JSX.Element => {
    return (
      <>
        <AddPost open={open} setOpen={setOpen} />

        <Popconfirm
          placement="leftTop"
          title={"Xác nhận gửi thông báo !"}
          description={"Bạn có muốn gửi thông báo tới tất cả email này không ?"}
          onConfirm={() => handleSendEmail()}
          okText="Xác nhận"
          cancelText="Hủy">
          <Button type="primary" icon={<SendOutlined />}>
            Send Email
          </Button>
        </Popconfirm>
      </>
    );
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <PostSearch handleSearch={handleSearch} />
        </Col>
      </Row>
      <DataTable
        columns={columns}
        data={emailFollow?.result}
        total={emailFollow?.meta.total}
        loading={open}
        modalAdd={handleModalCreate}
        name="Email Follow"
        setSearchPagination={setSearchPagination}
      />
    </>
  );
}

export default EmailFollow;
